module.exports = __webpack_public_path__ + "static/media/ios.e6604d12.svg";